import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage"; // ✅ add



const firebaseConfig = {
  apiKey: "AIzaSyAPAW1EIsdFLb-vWyQQwOT8V-HuVQ2rkac",
  authDomain: "trustfix-establishment.firebaseapp.com",
  projectId: "trustfix-establishment",
  storageBucket: "trustfix-establishment.firebasestorage.app",
  messagingSenderId: "140199559019",
  appId: "1:140199559019:web:ad35dafa5c608f336c962e",
  databaseURL: "https://trustfix-establishment-default-rtdb.europe-west1.firebasedatabase.app/"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // ✅ add
